import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import dynamic from "next/dynamic";
import React, { FC, useContext } from "react";

import { AppContext } from "../../lib/appContext";
import { APP_BAR_ID } from "../constants";

const TopbarDesktop = dynamic(() => import("./desktop").then(mod => mod.Topbar));
const TopbarMobile = dynamic(() => import("./mobile").then(mod => mod.Topbar));

const styles: StyleRulesCallback = ({ breakpoints }) => ({
  hideOnDesktop: {
    [breakpoints.up("md")]: {
      display: "none"
    }
  },
  hideOnMobile: {
    [breakpoints.down("sm")]: {
      display: "none"
    }
  }
});

export interface TopbarProps {
  showMenu?: boolean;
}

const Topbar: FC<TopbarProps & WithStyles<typeof styles>> = ({ classes, showMenu }) => {
  const { topbar, isMobile } = useContext(AppContext);
  const { menu, phone } = topbar;
  const topbars = [
    <div key="topbar-mobile" className={classes.hideOnDesktop}>
      <TopbarMobile menu={menu} phone={phone} showMenu={showMenu} />
    </div>
  ];

  if (!isMobile) {
    topbars.push(
      <div className={classes.hideOnMobile}>
        <TopbarDesktop key="topbar-desktop" menu={menu} phone={phone} showMenu={showMenu} />
      </div>
    );
  }

  return (
    <>
      {topbars}
      <div id={APP_BAR_ID} />
    </>
  );
};

const StyledTopbar = withStyles(styles)(Topbar);

export { StyledTopbar as Topbar };
